var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "horizontal-carousel js-horizontal-carousel",
      attrs: {
        "data-visible-items": _vm.items,
        "data-thumbnails": _vm.thumbnails
      }
    },
    [
      _c(
        "div",
        { staticClass: "horizontal-carousel-content" },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { "data-prev": "" } }, [
      _c("i", { staticClass: "fas fa-angle-left fa-2x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { "data-next": "" } }, [
      _c("i", { staticClass: "fas fa-angle-right fa-2x" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }